<template>
  <div class="notice-view">
    <el-card>
      <div slot="header" class="clearfix">
        <span>通知详情</span>
      </div>
      <div class="notice">
        <div class="left-list">
          <ul>
            <li v-for="(i, index) in msgInfo" :key="index" @click="selMsg(i, index)" :class="currentIndex === index ? 'active': ''">
              <p>{{i.title}}</p>
              <span></span>
            </li>
          </ul>
        </div>
        <div class="cont-right">
          <div class="top-title">
            <p class="title">{{title}}</p>
            <div class="info-time">
              <span>{{createTime | dateFormat('yyyy-M-d hh:mm')}}</span>
            </div>
          </div>
          <span class="c-line"></span>
          <div class="cont">
            <p v-html="des"></p>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import ApiService from "@/services/API-services";
export default {
  name: "noticeView",
  props: ['modalInfo'],
  data() {
    return {
      msgInfo: [],
      currentIndex: 0,
      page: 1,
      linit: 20,
      title: '',
      des: '',
      createTime: '',
      initInfo: null
    }
  },
  created() {
    this.initInfo = this.modalInfo
    this.getSysNotice()
    this.noticeSocket()
  },
  methods: {
    noticeSocket() {
      let _this = this
      const ws = new WebSocket(`${window.R_config.warnSocket}`)
      ws.onopen = function() {
        console.log('连接公告')
        // ws.send(`NoticeID=${res.ID}`)
      },
      ws.onmessage = function(data) {
        console.log(data)
        _this.getSysNotice()
      }
    },
    getSysNotice() {
      ApiService.user
        .getSysMessage({
          userId: JSON.parse(localStorage.user).userId,
          page: this.page,
          linit: this.linit,
          IsRead: 1, // 1=所有  2=未读 3=已读
        })
        .then((res) => {
          this.msgInfo = res.data;
          if (this.initInfo) {
            let vindex
            this.msgInfo.map((n, index) => {
              if (n.id === this.initInfo.id) {
                vindex = index
              }
            })
            this.selMsg(this.initInfo, vindex)
          } else {
            this.selMsg(res.data[0], 0)
          }
        });
    },
    selMsg(i, index) {
      this.currentIndex = index
      this.title = i.title
      this.des = i.des
      this.createTime = i.createTime
      this.initInfo = i
      if (i.isRead === 2) {
        this.updateNotice(i)
      }
    },
    updateNotice(val) {
      let arr = []
      if (val) {
        let arr1 = JSON.parse(val.json)
        arr1.push(JSON.parse(localStorage.user).userId)
        arr.push({
          id: val.id,
          json: JSON.stringify(arr1)
        })
      } else {
        this.msgInfo.map(n => {
          arr.push({
            id: n.id,
            json: JSON.stringify([JSON.parse(localStorage.user).userId])
          })
        })
      }
      ApiService.user.updateNotice({
          arrParam: arr
      }).then(res =>{
        this.getSysNotice()
      })
    },
  },
};
</script>

<style lang="scss">
@import "../../common/css/color.scss";
.notice-view {
  width: 1200px;
  .el-card__body {
    padding: 0;
    .notice {
      display: flex;
      height: 540px;
      color: $font_color;
      .left-list {
        width: 200px;
        text-align: left;
        background: #021021;
        ul {
          height: 540px;
          overflow: auto;
          li {
            padding: 5px 20px;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.65);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:hover {
              color: $font_color;
              background: $active_color;
            }
          }
          .active {
            color: $font_color;
            background: $active_color;
          }
        }
      }
      .cont-right {
        padding: 24px;
        width: 952px;
        .top-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .title {
            font-size: 16px;
            color: #fff;
            text-align: left;
          }
          .info-time {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.65);
          }
        }
        .c-line {
          display: inline-block;
          width: 100%;
          height: 2px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          margin: 12px 0;
        }
        .cont {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.85);
          text-align: left;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mind/noticeView.vue